var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoodHealthColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 896",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2500",
    d: "M8 4l1.3-1.625A1 1 0 0110.081 2h3.839a1 1 0 01.781.375L16 4h0v1a1 1 0 01-1 1H9a1 1 0 01-1-1V4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2501",
    d: "M9.667 9.333L8 11l-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2502",
    d: "M13 10h3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2503",
    d: "M11.191 20H6a2 2 0 01-2-2V6a2 2 0 012-2h2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2504",
    d: "M16 4h2a2 2 0 012 2v3.684"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2511",
    d: "M7 15h3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12726",
    d: "M18 20.175l2.4 1.251a.636.636 0 00.924-.666l-.458-2.651 1.942-1.877a.631.631 0 00-.353-1.078l-2.683-.387-1.201-2.417a.639.639 0 00-1.142 0l-1.2 2.414-2.683.386a.631.631 0 00-.353 1.078l1.942 1.877-.458 2.655a.636.636 0 00.924.666L18 20.175"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2512",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgGoodHealthColored;


//////////////////
// WEBPACK FOOTER
// ./src/icons/goodHealthColored.svg
// module id = 764
// module chunks = 13